<template>
  <dara-single-content-layout container-size="lg">
    <template #content>
      <dara-header v-if="isEditing">
        {{ $t('editing-question') }}
      </dara-header>
      <dara-header v-else>
        {{ $t('new-question') }}
      </dara-header>
      <dara-p v-if="isEditing" class="dara-u-text--medium">
        {{ $t('editing-question-info1') }}
      </dara-p>
      <dara-p v-else class="dara-u-text--medium">
        {{ $t('creating-question-info1') }}<br>
        {{ $t('creating-question-info2') }}
      </dara-p>
      <dara-question-edit-inputs @save="saveQuestion" />
    </template>
  </dara-single-content-layout>
</template>

<script>
import { toastError } from '@/services/toastService';
import { goHistoryBack } from '@/router/route.service';
import { QUESTION_ERRORS } from '@/modules/question/question.constants';
import { getters } from '@/modules/user/user.store';
import { goToOpenQuestion, goToQuestionNotFound, goToQuestionForbidden } from '@/modules/question/question.routes';
import { saveQuestion, getQuestion } from '@/modules/question/question.service';
import { translate } from '@/services/translate.service';

import DaraQuestionEditInputs from '@/modules/question/components/QuestionEditInputs.vue';
import DaraSingleContentLayout from '@/layouts/SingleContentLayout.vue';

export default {
  name: 'DaraQuestionEditPage',
  components: {
    DaraQuestionEditInputs,
    DaraSingleContentLayout,
  },
  provide() {
    const questionEditVm = {};
    Object.defineProperty(questionEditVm, 'question', {
      get: () => this.question,
    });
    return { questionEditVm };
  },
  data() {
    return {
      question: null,
      user: getters.getUser(),
    };
  },
  computed: {
    id() {
      return this.$route.params?.id;
    },
    isEditing() {
      return !!this.question?.id;
    },
  },
  mounted() {
    if (this.id) {
      this.fetchQuestion();
    } else {
      this.question = {
        anonymous: false,
      };
    }
  },
  methods: {
    goHistoryBack,
    fetchQuestion() {
      getQuestion(this.id)
        .then(data => {
          this.question = data.data;
          if (this.question.answered || this.question.user.id !== this.user.id) {
            goToQuestionForbidden(this.$router);
          }
        })
        .catch(err => {
          this.question = null;
          if ((err.response.data.errors === QUESTION_ERRORS[err.response.status] && err.response.status === 404)) {
            goToQuestionNotFound(this.$router);
          } else {
            toastError(`${translate('error-on-fetching-question')}`);
          }
        });
    },
    saveQuestion() {
      if (!this.question.department_id) {
        toastError(`${translate('you-need-to-specify-the-question-department')}`);
        return;
      }
      saveQuestion(this.question)
        .then(data => {
          goToOpenQuestion(this.$router, data || this.question);
        })
        .catch(() => toastError(`${translate('we-could-not-save-your-question-at-this-moment')}`));
    },
  },
};
</script>
